<template lang="pug">
  v-autocomplete(
    :items="activities"
    :value="value"
    item-value="id"
    item-text="name"
    :search-input.sync="search"
    label="Вид деятельности"
    no-filter
    rounded
    filled
    v-bind="$attrs"
    @change="emitValue($event)"
  )
</template>

<script>
import _debounce from 'lodash/debounce';
import SystemService from '@/services/API/SystemService';

export default {
  name: 'SelectActivity',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    directionId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    activities: [],
    search: '',
  }),
  watch: {
    search(val) {
      this.loadActivities(val);
    },
    directionId() {
      this.loadActivities();
    },
  },
  mounted() {
    if (this.value) {
      this.loadActivities(this.value);
    } else {
      this.loadActivities();
    }
  },
  methods: {
    loadActivities: _debounce(function (val) {
      const params = {
        'search[name]': val,
        'search[direction_id]': this.directionId,
      };
      SystemService.getActivities(params)
        .then((r) => {
          this.activities = r.data.data;
        });
    }, 500),
    emitValue(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
